<template>
  <b-col md="2" class="bg-light sidebar sidebar-l" id="sidebar-left">
    <div class="sidebar-sticky" v-if="loaded">
      <ul class="nav flex-column">

          <li class="nav-item">
            <router-link to="/alta-base" class="nav-link">
              <span data-feather="database"></span>
              Copia en vivo
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/restaurar-base" class="nav-link">
              <span data-feather="upload-cloud"></span>
              Copia de base desde Backup
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/lista-servidores" class="nav-link">
              <span data-feather="server"></span>
              Lista Servidores
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/limpieza-backups" class="nav-link">
              <span data-feather="trash-2"></span>
              Limpieza de backups
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/lista-clientes" class="nav-link">
              <span data-feather="users"></span>
              Lista Clientes/Bases
            </router-link>
          </li>

          <li class="nav-item">
            <a class="nav-link change-page" href="#">
              <span data-feather="list"></span>
              Exploracion de backups
            </a>
          </li>

          <li class="nav-item">
            <router-link to="/uploads" class="nav-link">
              <span data-feather="tablet"></span>
              Carga de Datos
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/reset-password" class="nav-link">
              <span data-feather="tablet"></span>
              Resetear usuario Mobile
            </router-link>
          </li>

        <!-- Ítem siempre visible: Chatbot -->
        <li class="nav-item">
          <router-link to="/chat" class="nav-link">
            <span data-feather="message-circle"></span>
            Chatbot
          </router-link>
        </li>
      </ul>

      <!-- Documentación visible solo para staff -->
      <template v-if="isStaff">
        <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
          <span>Documentacion</span>
          <a class="d-flex align-items-center text-muted" href="#" aria-label="Add a new report">
            <span data-feather="plus-circle"></span>
          </a>
        </h6>
        <ul class="nav flex-column mb-2">
          <li class="nav-item">
            <a class="nav-link" href="#">
              <span data-feather="file-text"></span>
              Instalaciones Sistemas
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              <span data-feather="file-text"></span>
              Reiniciar MySQL
            </a>
          </li>
        </ul>
      </template>
    </div>
  </b-col>
</template>

<script>
import axios from 'axios'
import feather from "feather-icons"

export default {
  name: 'SidebarLeft',
  data() {
    return {
      isStaff: false,
      loaded: false
    };
  },
  mounted() {
    const token = localStorage.getItem("usertoken");

    if (token) {
      axios.get("https://it-backend.synagro.com.ar/api/v1.0/user-role/", {
        headers: {
          Authorization: `Token ${token}`
        }
      })
      .then(response => {
        this.isStaff = response.data.is_staff;
      })
      .catch(error => {
        console.error("Error consultando rol del usuario:", error);
        this.isStaff = false;
      })
      .finally(() => {
        this.loaded = true;
        feather.replace();
      });
    } else {
      this.loaded = true;
      feather.replace();
    }
  },
}
</script>

<style scoped>
  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    padding: 48px 0 0;
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
  }

  @media (max-width: 767.98px) {
    .sidebar {
      top: 5rem;
    }
  }

  .sidebar-sticky {
    position: relative;
    top: 0;
    height: calc(100vh - 48px);
    padding-top: .5rem;
    overflow-x: hidden;
    overflow-y: auto;
  }

  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
    }
  }

  .sidebar .nav-link {
    font-weight: 500;
    color: #333;
  }

  .sidebar .nav-link .feather {
    margin-right: 4px;
    color: #999;
  }

  .sidebar .nav-link.active {
    color: #007bff;
  }

  .sidebar .nav-link:hover .feather,
  .sidebar .nav-link.active .feather {
    color: inherit;
  }

  .sidebar-heading {
    font-size: .75rem;
    text-transform: uppercase;
  }

  .feather {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
  }
</style>
